import React from 'react';
import { Button } from 'flowbite-react';
import SubjectCarousel from '../carousel/SubjectCarousel';

const HomeSubj = () => {
  return (
    <div id="home_subj" className="body-custom w-full min-h-screen text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-10">
        
        {/* Grid Layout - 2 columns on desktop, 1 on mobile */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center min-h-screen py-12 lg:py-0">
          
          {/* Left Column - Text Content */}
          <div className="flex flex-col justify-center space-y-6 lg:space-y-8 order-2 lg:order-1">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-thin text-center lg:text-left">
              Browse All Subjects
            </h1>

            <p className="text-base sm:text-lg lg:text-xl font-thin text-center lg:text-left leading-relaxed">
              EduBahamas contains a comprehensive list of subjects for both the BGCSE and
              BJC examinations. Ranging from the languages all the way to
              business studies - browse all subjects by clicking the button!
            </p>

            <a href="/subjects" className="w-full">
              <Button className="w-full text-base sm:text-lg py-3">
                View All Subjects
              </Button>
            </a>
          </div>

          {/* Right Column - Carousel */}
          <div className="flex items-center justify-center order-1 lg:order-2">
            <SubjectCarousel />
          </div>

        </div>
      </div>
    </div>
  );
};

export default HomeSubj;